// @ts-strict-ignore
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LMUniqueIdService } from '@utils/lm-unique-id.service';
import { AppConstants } from "@app/utils";
import { LMFilterBuilderService } from "@app/components";

@Component({
  selector:    'lm-filter-builder-row',
  templateUrl: './lm-filter-builder-row.component.html',
  styleUrls:   [ './lm-filter-builder-row.component.scss' ]
})
export class LMFilterBuilderRowComponent implements OnInit {

  @Input() filterRow: FilterRow;
  @Input() businessClass: string;
  @Input() includeAuditFields: boolean;
  @Input() lookupUrl: string;
  @Input() index: number;
  @Input() fieldSearchUrl: string;
  @Input() lplValidationUrl: string;

  @Output() onFieldLookUpEvent = new EventEmitter<LMFieldLookUpEvent>();
  @Output() onRemoveRowEvent = new EventEmitter<LMFilterBuilderRemoveRowEvent>();

  conditions: Array<FilterConditionOption>;
  options: Array<FilterOptionOption>;
  hasPredicate: boolean;
  literalId: string;
  checkboxId: string;
  operatorId: string;
  optionId: string;
  conditionAutomationId: SohoAttributesArray;
  optionAutomationId: SohoAttributesArray;
  rowNum: number;
  datePickerOptions: SohoDatePickerOptions = {
    mode: 'standard',
    dateFormat: Soho.Locale.calendar().dateFormat.short,
    showMonthYearPicker: true
  };
  
  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private lmUniqueIdService: LMUniqueIdService,
    private lmFilterBuilderService: LMFilterBuilderService) {
  }

  ngOnInit() {
    this.buildConditions();
    this.updateHasPredicate();
    this.buildOptions();
    this.updateDatePickerOptions();

    this.rowNum = this.filterRow?.uniqueIdentifier ? this.filterRow?.uniqueIdentifier : this.index;
    this.literalId = this.lmUniqueIdService.uniqueId([ 'literal', this.rowNum.toString() ]);  // are these needed
    this.checkboxId = this.lmUniqueIdService.uniqueId([ 'checkbox', this.rowNum.toString() ]); // // are these needed
    this.operatorId = this.lmUniqueIdService.uniqueId([ 'operator', this.rowNum.toString() ]);
    this.conditionAutomationId = [ { name: 'data-automation-id', value: `lm-filter-builder-row-condition-${this.rowNum}` } ];
    this.optionAutomationId = [ { name: 'data-automation-id', value: `lm-filter-builder-row-option-${this.rowNum}` } ];
  }

  private buildConditions() {
    this.conditions = this.lmFilterBuilderService.updateFilterRowConditions(this.filterRow);
  }

  private buildOptions() {
    this.options = this.lmFilterBuilderService.updateFilterRowOptions(this.filterRow);
  }

  private updateDatePickerOptions() {
    switch (this.filterRow.subject.fieldType) {
        // date and time
      case AppConstants.TIMESTAMP:
        this.datePickerOptions = {
          incrementWithKeyboard: true,
          todayWithKeyboard: true,
          dateFormat: Soho.Locale.calendar().dateFormat.short + ' ' + Soho.Locale.calendar().dateFormat.timestamp,
          showTime: true
        };

        break;

        // year only
      case AppConstants.YYYY:
        this.datePickerOptions = {
          incrementWithKeyboard: true,
          todayWithKeyboard: true,
          dateFormat: 'yyyy',
          showMonthYearPicker: true,
          hideDays: true
        };

        break;

        // period / birthday
      case AppConstants.YYYYMM:
        this.datePickerOptions = {
          incrementWithKeyboard: true,
          todayWithKeyboard: true,
          dateFormat: Soho.Locale.calendar().dateFormat.year,
          hideDays: true,
        };
        break;

        // year, month, day
      case AppConstants.YYYYMMDD:
        this.datePickerOptions = {
          incrementWithKeyboard: true,
          todayWithKeyboard: true,
          dateFormat: Soho.Locale.calendar().dateFormat.short,
          showMonthYearPicker: true,
        };

        break;

        // Anniversary
      case AppConstants.MMDD:
        this.datePickerOptions = {
          incrementWithKeyboard: true,
          todayWithKeyboard: true,
          dateFormat:  Soho.Locale.calendar().dateFormat.month,
        };
        break;
    }
  }

  private updateHasPredicate() {
    this.hasPredicate = this.lmFilterBuilderService.hasPredicate(this.filterRow);
  }

  onRemoveButtonEvent() {
    this.filterRow.index = this.index;
    this.onRemoveRowEvent.emit({ filterRow: this.filterRow });
  }

  handleFieldLookUpEvent(event: LMFieldLookUpEvent, source: string) {
    if (event?.qualifier && source === 'subject') {
      this.filterRow.subject.type = event.qualifier.type;
      this.filterRow.condition = undefined;
      this.filterRow.option = undefined;
      this.filterRow.predicate = {text: '', type: ''};

      this.buildConditions();
      this.updateHasPredicate();
      this.buildOptions();
      this.updateDatePickerOptions();
    }

    // this.changeDetectorRef.detectChanges();
  }

  onConditionChanged() {

    this.buildOptions();
    this.updateHasPredicate();
  }

  onOptionChanged() {
    this.updateHasPredicate();
  }
}
